import { useParams } from 'react-router-dom';
import { SpaceForm } from '~/components/space/SpaceForm';

export default function SiteSpaceNew() {
  const { siteId } = useParams();

  return (
    <div className='h-full overflow-hidden'>
      <SpaceForm title='New Space' reload={() => {}} />
    </div>
  );
}
